<template>
    <a-form :form="form" @submit.prevent="handleSubmit">
        <a-form-item :label="$t('modules.type')">
            <a-select v-model="form.type">
                <a-select-option value="module">{{ $t("modules.module") }}</a-select-option>
                <a-select-option value="relation">{{ $t("modules.relation") }}</a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item :label="$t('modules.moduleRelationName')">
            <a-input v-model="form.displayName" />
        </a-form-item>

        <a-form-item :label="$t('modules.moduleRelationTable')">
            <a-select v-model="form.table">
                <a-select-option v-for="table in tables" :key="table._id" :value="table._id">
                    {{ table.name }}
                </a-select-option>
            </a-select>
        </a-form-item>

        <a-collapse v-if="form.type === 'relation'">
            <a-collapse-panel :header="$t('modules.relationSettings')" key="1">
                <a-form-item :label="$t('modules.remoteField')" v-if="form.table">
                    <a-select v-model="form.relation.remoteField">
                        <a-select-option
                            v-for="field in getTableFields(form.table,true)"
                            :key="field._id"
                            :value="field._id"
                        >
                            {{ field.name }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('modules.relationType')">
                    <a-select v-model="form.relation.moduleType" @change="handleModuleTypeChange">
                        <a-select-option value="standart">{{ $t("modules.standartModule") }}</a-select-option>
                        <a-select-option value="custom">{{ $t("modules.customTable") }}</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item v-if="form.relation.moduleType === 'standart'" :label="$t('modules.standartModule')">
                    <a-select v-model="form.relation.module">
                        <a-select-option value="contact">{{ $t("modules.contact") }}</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item v-if="form.relation.moduleType === 'custom'" :label="$t('modules.customTable')">
                    <div>
                        <a-select v-model="form.relation.module">
                            <a-select-option v-for="table in tables" :key="table._id" :value="table._id">
                                {{ table.name }}
                            </a-select-option>
                        </a-select>

                        <a-form-item :label="$t('modules.localField')" v-if="form.relation.module">
                            <a-select v-model="form.relation.custom.localField">
                                <a-select-option
                                    v-for="field in getTableFields(form.relation.module, true)"
                                    :key="field._id"
                                    :value="field._id"
                                >
                                    {{ field.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </div>
                </a-form-item>

                <div style="display: flex; gap: 16px" v-if="form.relation.moduleType === 'standart'">
                    <a-form-item :label="$t('modules.localFieldType')" style="flex: 1">
                        <a-select v-model="form.relation.standart.localFieldType">
                            <a-select-option value="standart">{{ $t("modules.standart") }}</a-select-option>
                            <a-select-option v-if="form.relation.module === 'contact'" value="custom"
                                >{{ $t("modules.custom") }}</a-select-option
                            >
                        </a-select>
                    </a-form-item>

                    <a-form-item
                        v-if="form.relation.standart.localFieldType === 'standart'"
                        :label="$t('modules.localField')"
                        style="flex: 1"
                    >
                        <a-select v-model="form.relation.standart.localField">
                            <a-select-option value="_id">_id</a-select-option>
                            <a-select-option v-if="form.relation.module === 'contact'" value="whatsappNumber"
                                >whatsappNumber</a-select-option
                            >
                            <a-select-option v-if="form.relation.module === 'contact'" value="email"
                                >email</a-select-option
                            >
                        </a-select>
                    </a-form-item>

                    <a-form-item
                        v-if="form.relation.standart.localFieldType === 'custom'"
                        :label="$t('modules.localField')"
                        style="flex: 1"
                    >
                        <a-select v-model="form.relation.standart.localField">
                            <a-select-option v-for="prop in contactProperties" :key="prop._id" :value="prop._id">
                                {{ prop.label }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </div>
                <a-form-item :label="$t('modules.showingRemoteFieldInList')" style="flex: 1" v-if="form.table">
                    <a-select v-model="form.relation.showingRemoteFieldInList">
                        <a-select-option
                            v-for="field in getTableFields(form.table)"
                            :key="field._id"
                            :value="field._id"
                        >
                            {{ field.name }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-collapse-panel>
        </a-collapse>

        <a-form-item :label="$t('modules.settings')">
            <a-checkbox v-model="form.settings.showInMainMenu">{{ $t("modules.showInMainMenu") }}</a-checkbox>
            <a-checkbox v-model="form.settings.apiEnabled">{{ $t("modules.apiEnabled") }}</a-checkbox>
        </a-form-item>

        <a-form-item :label="$t('modules.icon')">
            <a-input v-model="form.icon" />
        </a-form-item>

        <a-form-item>
            <a-button type="primary" html-type="submit">{{ $t("modules.createModule") }}</a-button>
        </a-form-item>
    </a-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
    data() {
        return {
            form: {
                type: "module",
                displayName: "",
                table: null,
                relation: {
                    moduleType: "standart",
                    module: "contact",
                    standart: {
                        localFieldType: "standart",
                        localField: "_id",
                    },
                    custom: {
                        localField: null,
                    },
                    showingRemoteFieldInList: null,
                },
                settings: {
                    showInMainMenu: true,
                    apiEnabled: true,
                },
                icon: "",
            },
        };
    },
    computed: {
        ...mapState({
            tables: (state) => state.table.tables,
            contactProperties: (state) => state.contactProperty.data,
        }),
    },
    methods: {
        ...mapActions({
            createModule: "module/createModule",
            syncModules: "module/syncModules",
        }),
        async handleSubmit() {
            const { type, table, relation, settings, icon } = this.form;
            await this.createModule({
                displayName: this.form.displayName,
                description: this.form.description,
                type,
                table,
                relation,
                settings,
                icon,
            }).catch((error) => {
                this.$message.error(this.$t('modules.createFailed'));
            });
            this.$message.success(this.$t('modules.createSuccess'));
            this.$emit("success");
            this.syncModules();
        },

        getTableFields(tableId, includeIDField = false) {
            const table = this.tables.find((t) => t._id === tableId);
            let fields = table?.fields || [];
            if (table && includeIDField) {
                fields = [
                    {
                        _id: "_id",
                        name: "ID",
                        type: "string",
                    },
                    ...fields,
                ];
            }
            return fields;
        },
        handleModuleTypeChange(value) {
            console.log("handleModuleTypeChange", value);
            this.form.relation.moduleType = value;
            if (value === "standart") {
                this.form.relation.module = "contact";
            } else {
                this.form.relation.module = this.tables[0]?._id;
            }
        },
    },
    watch: {
        "form.type"() {
            if (this.form.type === "module") {
                this.form.relation = {
                    moduleType: "standart",
                    module: "contact",
                    standart: {
                        localFieldType: "standart",
                        localField: "_id",
                    },
                    custom: {
                        localField: null,
                    },
                    showingRemoteFieldInList: null,
                };
            }
        },
    },
    created() {},
};
</script>
